import { Signal, useSignal } from "@preact/signals";
import { useAppData } from "./App.tsx";
import { ExamplePrompt } from "db";
import { Ref } from "preact";

export function Templates({ submit, mode, textareaRef }: { submit: () => Promise<void>, mode: Signal<number | undefined>, textareaRef: Ref<HTMLTextAreaElement> }) {
  const { examplePrompts, isStartPage } = useAppData();

  if (!isStartPage.value) return <></>;

  function openTemplate(template: ExamplePrompt) {
    if (!textareaRef.current) return;
    textareaRef.current.value = template.prompt;
    mode.value = template.mode_id;
    submit();
  }

  return <div class="templates-container">
    {/* <h3>Example Prompts</h3> */}
    <br />
    <div className="templates">
      {examplePrompts.value.map(t => <button key={t.id} onClick={() => openTemplate(t)} class="template">
        <div class="template-name">{t.name}</div>
      </button>)}
    </div>
  </div>
}